import { render } from "./Card.vue?vue&type=template&id=50c7bfe5"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/Card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50c7bfe5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50c7bfe5', __exports__)) {
    api.reload('50c7bfe5', __exports__)
  }
  
  module.hot.accept("./Card.vue?vue&type=template&id=50c7bfe5", () => {
    api.rerender('50c7bfe5', render)
  })

}


export default __exports__